import { css } from '@emotion/react';
import styled from '@emotion/styled';

import AccordionBase from 'components/global/Accordion';
import GlobalCard from 'components/global/Card';
import Image from 'components/global/Image';

import { Breakpoints } from 'utils/const.styles';

export const Wrapper = styled.div`
	min-height: inherit;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding: 3.5rem;
	.section-padding-bottom {
		padding-bottom: 2.5rem;
	}
	.section-margin-bottom {
		margin-bottom: 2.5rem;
	}
	.text-center {
		text-align: center;
	}
	@media ${Breakpoints.tablet} {
		padding: 3rem 2.5rem;
	}
	@media ${Breakpoints.mobile} {
		padding: 3rem 2rem;
	}
	.skeleton {
		position: absolute;
		max-width: 500px !important;
	}
`;

export const Card = styled(GlobalCard)`
	border-radius: 3rem !important;
	min-height: inherit;
	width: 100%;
	overflow: unset;
`;

export const FormRow = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 1.8rem;
	gap: 3.8rem;
	position: sticky;
	bottom: 2rem;
	background-color: var(--white);
	> .typography {
		white-space: normal;
	}
`;

export const AccordionInner = styled.div`
	display: flex;
	justify-content: space-between;
`;

export const ItemInfo = styled.div`
	display: flex;
	align-items: center;
	gap: 1rem;
`;

export const SubTitleAction = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	.subtitle-action {
		text-decoration: underline;
		user-select: none;
		cursor: pointer;
	}
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	padding-top: 4rem;
`;

export const AddressContainer = styled.div`
	padding-top: 4rem;
	.form-item {
		padding: var(--padding-2) 0;
	}
	& > div {
		padding-left: 0;
		&:last-child > .form-item {
			&:nth-of-type(2n + 1) {
				padding-left: 0;
			}
			&:nth-of-type(2n + 2) {
				padding-right: 0;
				padding-left: var(--padding-2);
			}
			body[dir='rtl'] & {
				&:nth-of-type(2n + 1) {
					padding-right: 0;
				}
				&:nth-of-type(2n + 2) {
					padding-right: var(--padding-2);
					padding-left: 0;
				}
			}
		}
	}
	.subtitle {
		padding-bottom: 1.8rem;
	}
`;

export const Form = styled.div`
	background-color: var(--white);
	border-radius: var(--small-border-radius);
	overflow: auto;
	display: flex;
	flex-wrap: wrap;
	width: 100%;
	border: none;
	background-color: transparent;
	padding-top: 1.8rem;
	.form-item {
		&:nth-of-type(2n + 1) {
			padding-left: 0;
		}
		&:nth-of-type(2n + 2) {
			padding-right: 0;
		}
		body[dir='rtl'] & {
			&:nth-of-type(2n + 1) {
				padding-left: var(--padding-2);
				padding-right: 0;
			}
			&:nth-of-type(2n + 2) {
				padding-right: var(--padding-2);
				padding-left: 0;
			}
		}
	}
	@media ${Breakpoints.mobileLandscape} {
		display: block;
		padding: var(--padding-2) 0;
		.form-item {
			padding: var(--padding-3) 0 !important;
		}
	}
`;

export const ProductImage = styled(Image)`
	max-width: 5.5rem;
	max-height: 5.5rem;
	object-fit: contain;
	border-radius: var(--small-border-radius);
	cursor: pointer;
	&:hover {
		opacity: 0.8;
	}
`;

export const Accordion = styled(AccordionBase)`
	width: 100%;
	margin-top: 3.5rem;
`;

export const Bold = styled.span`
	font-weight: 700;
	font-size: var(--heading4-font-size);
`;

export const PaymentContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 3rem;
`;

export const PaymentCollapse = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 1rem;
	width: 100%;
	padding: 1.5rem 0;
	overflow: hidden;
	cursor: pointer;
`;

export const ConfirmOrderContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;

export const ShippingMethodWrapper = styled.div`
	display: flex;
	flex-direction: column;
	border-radius: 0.5rem;
	gap: 2rem;
`;

export const ShippingMethodCard = styled.button`
	background-color: var(--white);
	border: 0.1px solid var(--border-color);
	border-radius: 0.5rem;
	width: 100%;
	padding: 0;
	cursor: pointer;

	&.selected {
		border-color: var(--blue);
	}
	:disabled {
		background: #f6f6f6;
		border: none;
		cursor: default;
	}
`;

export const ShippingMethodCardBadge = styled.div`
	background-color: var(--blue);
	width: fit-content;
	padding: 0.5rem 3rem;
	border-bottom-right-radius: 1.4rem;
	border-top-left-radius: 0.5rem;
	body[dir='rtl'] & {
		border-radius: 0;
		border-bottom-left-radius: 1.4rem;
		border-top-left-radius: 0.5rem;
		border-left: 1px solid var(--border-color) !important;
	}
`;

export const ShippingMethodCardContainer = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 1.5rem 3rem;
`;

export const TitleContainer = styled.div`
	display: flex;
	gap: 1rem;
`;

export const DCLogo = styled(Image)`
	display: block;
	border-radius: var(--spacing-2);
`;

export const DCInfo = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: flex-start;
`;

export const DCServiceType = styled.div`
	background-color: var(--background-1);
	border-radius: var(--spacing-2);
	padding: 0.5rem 1rem;
`;

export const DCDropOffOptionContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding-top: 2rem;
	gap: 0.5rem;
`;

export const PaymentTypeButton = styled.button`
	width: 100%;
	height: 13.6rem;
	border-radius: var(--small-border-radius);
	background-color: var(--white);
	border: 1px solid var(--border-color);
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1.4rem;
	cursor: pointer;
	&.selected {
		border-color: var(--blue);
	}
	:disabled {
		background: #f6f6f6;
		border-color: unset;
		border: none;
		cursor: default;
	}
`;

export const ConfirmTabSummaryContainer = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
	border-radius: var(--small-border-radius);
	padding: 4.5rem 3rem;
	gap: 1.4rem;
	background-color: #f6f6f6;
	border: none;
	.address-text {
		width: 40%;
		white-space: unset;
		text-align: end;
	}
	&.summary-column {
		flex-direction: column;
		gap: 3rem;
	}
`;

export const ConfirmTabSummaryRow = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
`;

// order summary

export const OrderSummaryContainer = styled.div`
	position: sticky;
	top: 3rem;
	display: flex;
	flex-direction: column;
	width: 35%;
	max-width: 45rem;
	height: 100%;
	gap: 1.8rem;
	@media ${Breakpoints.tablet} {
		display: none;
		margin: 0 auto;
		width: 80%;
		max-width: unset;
	}
	@media ${Breakpoints.mobile} {
		width: 100%;
	}
`;

export const OrderSummaryContent = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 2rem;
	padding: 3.5rem 4rem;
	@media ${Breakpoints.tablet} {
		padding: 2rem 3rem;
	}
`;

export const OrderSummaryList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	max-height: 40vh;
	overflow: auto;
`;

export const OrderSummaryRow = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;

	${({ $hasLine }) =>
		$hasLine &&
		css`
			border-top: 1px solid var(--border-color);
			border-bottom: 1px solid var(--border-color);
			padding: 2rem 0;
		`}
	${({ $bottomLine }) =>
		$bottomLine &&
		css`
			border-bottom: 1px solid var(--border-color);
			padding-bottom: 2rem;
		`}
	${({ $topLine }) =>
		$topLine &&
		css`
			border-top: 1px solid var(--border-color);
			padding-top: 2rem;
		`}
`;

export const CheckboxContainer = styled.div`
	display: flex;
	gap: 0.7rem;

	input[type='checkbox'] {
		min-width: 2rem;
	}

	${({ hasError }) =>
		hasError &&
		css`
			.terms-and-privacy {
				color: var(--red);
			}
		`}
`;

export const ApplePayButtonContainer = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
`;

export const ApplePayButtonOverlay = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	background: transparent;
`;
